import { defineComponent, computed,onMounted } from "vue";
import Result from '@/components/Result/Result.vue'
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useGtag } from "vue-gtag-next";

import { TypeCard } from '@/types/Card'

export default defineComponent({
    name: "LuckydrawResult",
    components: { Result},
    setup() {
        
        const { pageview } = useGtag();
        const store = useStore();
        const router = useRouter();

        const CardData = computed(() => store.getters['Card/getCard'])

        onMounted(() => {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            pageview({ page_path: "/FormComplete" });
            // eslint-disable-next-line
            (window as any).fbq('track', 'CompleteRegistration') 
            

            if (  CardData.value.cardtype !=='Golden') {
                router.push('/')
            }else{
                const CardDataClear = <TypeCard>{
                    cardid:'',
                    cardtype: '',
                    registerid: ''
                }
            
                store.dispatch('Card/SetCard',CardDataClear)
            }
        })
    }
 })